import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { LoginComponent } from './pages/login/login.component';



const routes: Routes = [
  /***
   * 
   * Remember change the url in Appsettings
   */

  { path: 'login', component: LoginComponent },
  {path: 'main', loadChildren: './pages/main/main.module#MainModule', canActivate: [AuthGuard]},

  { path: '', redirectTo: 'main/home'  ,pathMatch: 'full'},
  { path: '**', redirectTo: 'main/home' },




];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
